module.exports = __webpack_public_path__ + "img/hg-3.f0300bce.jpg";